<template>
  <Search
    :url="url"
    :title="$lang.searchAlgorithmExercise"
    :remove_item="remove_item"
    addModalSize="lg"
    removeModalSize="xl"
    :toggleable="true"
    :dynamicButtons="buttons"
  >
    <template slot="addModal" slot-scope="search" config="exercise-algorithm">
      <AddExerciseAlgorithm isModal @modal-end-up="search.close" />
    </template>
  </Search>
</template>

<script>
import Search from "@/components/base/search";
import AddExerciseAlgorithm from "./addAlgorithm";

export default {
  components: {
    Search,
    AddExerciseAlgorithm,
  },
  data() {
    return {
      loadingItem: false,
      url:
        this.$config.api_url +
        this.$config.kanoon.exercise_algorithm.replace(
          "{0}",
          this.$route.params.id
        ),
      buttons: [
        {
          id: "0",
          name: "exerciseAlgorithm",
          text: this.$lang.search.exercise_algorithm_tooltip,
          iconFont: "fa fa-circle fa-lg text-info",
          click: this.showAlgorithmDetailSearch,
        },
      ],
    };
  },
  methods: {
    editItem(item) {},
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    showAlgorithmDetailSearch(item) {
      this.$router.push("/ac/exercise/" + item.id + "/algorithm/search");
    },
  },
};
</script>
